
export default function SampleEmails() {
  const samples = [
    {
      subject: 'Why we test your backflow preventer twice',
      preview: 'Most contractors test once and move on. Here\'s why we don\'t...',
      body: `Mike,

Quick one today.

We test your backflow preventer twice during every inspection.

First test: baseline reading.
Second test: verification.

Why?

Because a single test can miss intermittent failures. Debris shifts. Seals settle. Pressure fluctuates.

One test tells you what happened in that moment.
Two tests tell you what's actually happening.

It takes an extra 4 minutes.
It catches problems that would cost you thousands in contamination or failed inspections.

That's the difference.

— Tom
Fireline Services`
    },
    {
      subject: 'The sprinkler head nobody checks',
      // Changed to double‑quoted string to avoid unescaped apostrophe
      preview: "It's in your storage room. And it might be painted over...",
      body: `Sarah,

There's always one.

The sprinkler head in the back storage room that got painted over during the last renovation.

Painted heads don't work. The paint seals the heat-sensitive element. In a fire, it won't activate.

We check every head. Even the ones in the ceiling nobody looks at.

Because the one that doesn't work is always the one you need.

If you've had any painting or construction work done recently, let us know. We'll do a walkthrough.

— Tom
Fireline Services`
    },
    {
      subject: 'Your fire alarm panel is talking to you',
      preview: 'Here\'s what those codes actually mean...',
      body: `David,

Your fire alarm panel has a language.

Trouble codes. Supervisory signals. Alarm conditions.

Most people ignore them until something stops working.

Here's what they mean:

• Yellow light = supervisory (something's off, but not critical)
• Red light = alarm condition (needs immediate attention)
• Flashing = acknowledged but not resolved

If you see a yellow light, call us. We'll diagnose it remotely and schedule a fix before it becomes a red light.

Small problems stay small when you catch them early.

— Tom
Fireline Services`
    }
  ];

  return (
    <section id="samples" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Sample Email Preview
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Professional. Personality-driven. No fluff.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 mb-12">
          {samples.map((sample, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200 hover:border-red-600 transition-colors"
            >
              <div className="bg-white border-b border-gray-200 p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-2 h-2 bg-red-600 rounded-full"></div>
                  <span className="text-xs font-medium text-gray-500">SUBJECT</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">{sample.subject}</h3>
                <p className="text-sm text-gray-500">{sample.preview}</p>
              </div>
              <div className="p-6">
                <pre className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap font-sans">
                  {sample.body}
                </pre>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <p className="text-lg text-gray-600 mb-6">
            Want to see more examples tailored to your specific services?
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('sample-form');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-red-600 text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-download-line"></i>
            Download Sample Email Pack
          </button>
        </div>
      </div>
    </section>
  );
}
